import Vue from 'vue';
const DownloadExportButton = Vue.extend({
    props: {
        visible: { type: Boolean, default: false },
    },
});
export default DownloadExportButton;
